import { parseUnits } from 'viem'

import { SortBy } from '~/components/component-library/TokenSelector/types'

/**
 * Only flag an exceeds-balance error when sortBy='value' — that's the mode
 * where what you have IS what you can use. In sortBy='frequency' the parent
 * flow can cover the gap (e.g. send via auto-swap), so the inline error is
 * misleading.
 */
export const getExceedsBalance = ({
  selectedBalance,
  amount,
  decimals,
  sortBy,
}: {
  selectedBalance: { amount: bigint } | undefined
  amount: string
  decimals: number
  sortBy: SortBy
}): boolean => {
  if (!selectedBalance || !amount || sortBy !== 'value') return false
  try {
    return parseUnits(amount, decimals) > selectedBalance.amount
  } catch {
    return false
  }
}
